import { CURRENT_ENV } from 'config/config';
import { Market } from 'generated/event.types';

type StaticBiogenLincLinkMapper = { [key: string]: string };
export const previewDomainLinks: StaticBiogenLincLinkMapper = {
  fr: 'https://fr.preview.mybiogen.io',
  de: 'https://de.preview.mybiogen.io',
  gb: 'https://uk.preview.mybiogen.io',
  ie: 'https://ie.preview.mybiogen.io',
  it: 'https://it.preview.mybiogen.io',
  es: 'https://es.preview.mybiogen.io',
  at: 'https://at.preview.mybiogen.io',
  be: 'https://be.preview.mybiogen.io',
  ch: 'https://ch.preview.mybiogen.io',
  nl: 'https://nl.preview.mybiogen.io',
  pl: 'https://pl.preview.mybiogen.io',
  pt: 'https://pt.preview.mybiogen.io',
  au: 'https://au.preview.mybiogen.io',
  br: 'https://br.preview.mybiogen.io',
  ca: 'https://ca.preview.mybiogen.io',
  mx: 'https://mx.preview.mybiogen.io',
  jp: 'https://jp.preview.mybiogen.io',
  com: 'https://com.preview.mybiogen.io',
  gulf: 'https://gulf.preview.mybiogen.io',
  nordics: 'https://nordics.preview.mybiogen.io',
  ar: 'https://ar.preview.mybiogen.io',
};

const localUrl = 'https://app.mybiogen.io:3000';

const devDomainLinks = {
  [Market.at]: 'https://at.dev.mybiogen.io',
  [Market.au]: 'https://au.dev.mybiogen.io',
  [Market.be]: 'https://be.dev.mybiogen.io',
  [Market.br]: 'https://br.dev.mybiogen.io',
  [Market.ca]: 'https://ca.dev.mybiogen.io',
  [Market.com]: 'https://com.dev.mybiogen.io',
  [Market.de]: 'https://de.dev.mybiogen.io',
  [Market.es]: 'https://es.dev.mybiogen.io',
  [Market.fr]: 'https://fr.dev.mybiogen.io',
  [Market.gb]: 'https://uk.dev.mybiogen.io',
  [Market.ie]: 'https://uk.dev.mybiogen.io',
  [Market.it]: 'https://it.dev.mybiogen.io',
  [Market.jp]: 'https://jp.dev.mybiogen.io',
  [Market.mx]: 'https://mx.dev.mybiogen.io',
  [Market.pt]: 'https://pt.dev.mybiogen.io',
  [Market.ch]: 'https://ch.dev.mybiogen.io',
  [Market.nl]: 'https://nl.dev.mybiogen.io',
  [Market.pl]: 'https://pl.dev.mybiogen.io',
  [Market.us]: 'https://com.dev.mybiogen.io',
  [Market.gulf]: 'https://gulf.dev.mybiogen.io',
  [Market.nordics]: 'https://nordics.dev.mybiogen.io',
  [Market.ar]: 'https://ar.dev.mybiogen.io',
};

const stageDomainLinks = {
  [Market.at]: 'https://at.preprod.mybiogen.io',
  [Market.au]: 'https://au.preprod.mybiogen.io',
  [Market.be]: 'https://be.preprod.mybiogen.io',
  [Market.br]: 'https://br.preprod.mybiogen.io',
  [Market.ca]: 'https://ca.preprod.mybiogen.io',
  [Market.com]: 'https://com.preprod.mybiogen.io',
  [Market.de]: 'https://de.preprod.mybiogen.io',
  [Market.es]: 'https://es.preprod.mybiogen.io',
  [Market.fr]: 'https://fr.preprod.mybiogen.io',
  [Market.gb]: 'https://uk.preprod.mybiogen.io',
  [Market.ie]: 'https://uk.preprod.mybiogen.io',
  [Market.it]: 'https://it.preprod.mybiogen.io',
  [Market.jp]: 'https://jp.preprod.mybiogen.io',
  [Market.mx]: 'https://mx.preprod.mybiogen.io',
  [Market.pt]: 'https://pt.preprod.mybiogen.io',
  [Market.ch]: 'https://ch.preprod.mybiogen.io',
  [Market.nl]: 'https://nl.preprod.mybiogen.io',
  [Market.pl]: 'https://pl.preprod.mybiogen.io',
  [Market.us]: 'https://com.preprod.mybiogen.io',
  [Market.gulf]: 'https://gulf.preprod.mybiogen.io',
  [Market.nordics]: 'https://nordics.preprod.mybiogen.io',
  [Market.ar]: 'https://ar.preprod.mybiogen.io',
};

export const prodDomainLinks: StaticBiogenLincLinkMapper = {
  [Market.at]: 'https://biogenlinc.at',
  [Market.au]: 'https://biogenlinc.com.au',
  [Market.be]: 'https://biogenlinc.be',
  [Market.br]: 'https://biogenlinc.com.br',
  [Market.ca]: 'https://biogenlinc.ca',
  [Market.com]: 'https://biogenlinc.com',
  [Market.de]: 'https://biogenlinc.de',
  [Market.es]: 'https://biogenlinc.es',
  [Market.fr]: 'https://biogenlinc.fr',
  [Market.gb]: 'https://biogenlinc.co.uk',
  [Market.ie]: 'https://biogenlinc.co.uk',
  [Market.it]: 'https://biogenlinc.it',
  [Market.jp]: 'https://biogenlinc.jp',
  [Market.mx]: 'https://biogenlinc.mx',
  [Market.pt]: 'https://biogenlinc.pt',
  [Market.ch]: 'https://biogenlinc.ch',
  [Market.nl]: 'https://biogenlinc.nl',
  [Market.pl]: 'https://biogenlinc.pl',
  [Market.us]: 'https://biogenlinc.com',
  [Market.gulf]: 'https://gcc.biogenlinc.com',
  [Market.nordics]: 'https://nordics.biogenlinc.com',
  [Market.ar]: 'https://biogenlinc.com.ar',
};

export const getBaseUrlPerMarket = (market: Market, isPreview = false) => {
  switch (CURRENT_ENV) {
    case 'local': {
      return localUrl;
    }
    case 'dev': {
      return devDomainLinks[market as keyof typeof devDomainLinks];
    }
    case 'stage': {
      return stageDomainLinks[market as keyof typeof stageDomainLinks];
    }
    default:
      if (isPreview) {
        return previewDomainLinks[market as keyof typeof previewDomainLinks];
      }

      return prodDomainLinks[market as keyof typeof prodDomainLinks];
  }
};
